var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCommitteeAllowed)?_c('router-view',{attrs:{"committee":_vm.committee,"activeSectionType":_vm.activeSectionType},on:{"edit":_vm.edit,"open":_vm.open,"close":_vm.close}}):_c('e-404',{attrs:{"text":_vm.$t('common.contentNotAllowed')}})}
var staticRenderFns = []

export { render, staticRenderFns }